<template>
  <div>
    <div style="display:flex;justify-content:center;flex-wrap:wrap ">
      <!-- dropdown dominant -->
      <div :style="windowWidth > 780 ? 'max-width:340px;' : ''">
        <b-dropdown
          aria-role="list"
          :mobile-modal="false"
          v-model="selectedOptionsDom"
        >
          <div
            style="width:100%; margin-top:15px; display:flex;"
            slot="trigger"
          >
            <span style="font-size:12px;line-height:14px;cursor:pointer">{{
              $t("admin.filter.dominant")
            }}</span>
            <span
              style="font-weight:bold; font-size:14px;line-height:14px;;margin: 0px 10px; cursor:pointer"
              v-if="selectedOptionsDom === 4"
              >{{ $t("all_colors") }}</span
            >
            <span v-if="selectedOptionsDom === 0">
              <div
                style="background-color:#ed5b07; height:20px; width:20px; border-radius:20px;margin: 0px 10px; cursor:pointer"
              />
            </span>
            <span v-if="selectedOptionsDom === 1">
              <div
                style="background-color:#448dfe; height:20px; width:20px; border-radius:20px; margin: 0px 10px; cursor:pointer"
              />
            </span>
            <span v-if="selectedOptionsDom === 2">
              <div
                style="background-color:#9edb58; height:20px; width:20px; border-radius:20px; margin: 0px 10px; cursor:pointer"
              />
            </span>
            <span v-if="selectedOptionsDom === 3">
              <div
                style="background-color:#f6da50; height:20px; width:20px; border-radius:20px; margin: 0px 10px; cursor:pointer"
              />
            </span>
          </div>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="4"
            aria-role="listitem"
          >
            <span>{{ $t("all_colors") }}</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="0"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#ed5b07; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="1"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#448dfe; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="2"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#9edb58; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="3"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#f6da50; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <!-- dropdown inferieur -->
      <div :style="windowWidth > 780 ? 'max-width:340px;' : ''">
        <b-dropdown
          :mobile-modal="false"
          aria-role="list"
          v-model="selectedOptionsInf"
        >
          <div style="margin-top:15px;display:flex;" slot="trigger">
            <span>{{ " " }}{{ $t("admin.filter.inferieur") }}{{ " " }}</span>
            <span
              style="font-weight:bold; font-size:14px;margin: 0px 5px; cursor:pointer;line-height:14px;"
              v-if="selectedOptionsInf === 4"
              >{{ $t("all_colors") }}</span
            >
            <span v-if="selectedOptionsInf === 0">
              <div
                style="background-color:#ed5b07; height:20px; width:20px; border-radius:20px; cursor:pointer;margin: 0px 5px;"
              />
            </span>
            <span v-if="selectedOptionsInf === 1">
              <div
                style="background-color:#448dfe; height:20px; width:20px; border-radius:20px; cursor:pointer;margin: 0px 5px;"
              />
            </span>
            <span v-if="selectedOptionsInf === 2">
              <div
                style="background-color:#9edb58; height:20px; width:20px; border-radius:20px; cursor:pointer;margin: 0px 5px;"
              />
            </span>
            <span v-if="selectedOptionsInf === 3">
              <div
                style="background-color:#f6da50; height:20px; width:20px; border-radius:20px; cursor:pointer;margin: 0px 5px;"
              />
            </span>
          </div>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="4"
            aria-role="listitem"
          >
            <span>{{ $t("all_colors") }}</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="0"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#ed5b07; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="1"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#448dfe; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="2"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#9edb58; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="dropdownAction(selectedOptionsDom, selectedOptionsInf)"
            :value="3"
            aria-role="listitem"
          >
            <span>
              <div
                style="background-color:#f6da50; height:20px; width:20px; border-radius:20px"
              />
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedOptionsDom: 4,
      selectedOptionsInf: 4,
      copyInsight_resultats: "",
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(["insight_resultats"]),
  },
  mounted() {
    this.$store.commit("INSIGHT_ADMIN_DATA_COPY", this.insight_resultats);
    this.copyInsight_resultats = this.insight_resultats;
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  methods: {
    dropdownAction(dom, inf) {
      this.copyInsight_resultats = this.insight_resultats;
      this.$store.commit(
        "INSIGHT_ADMIN_DATA_COPY",
        this.copyInsight_resultats.filter((x) => {
          if (x.finish === 1) {
            let recupereJsonDom = x.profil[0];
            let recupereJsonInf = x.profil[1];
            if (
              (recupereJsonDom[0] === dom ||
                recupereJsonDom[1] === dom ||
                recupereJsonDom[2] === dom ||
                recupereJsonDom[3] === dom ||
                dom === 4) &&
              (recupereJsonInf[0] === inf ||
                recupereJsonInf[1] === inf ||
                recupereJsonInf[2] === inf ||
                recupereJsonInf[3] === inf ||
                inf === 4)
            ) {
              return recupereJsonDom && recupereJsonInf;
            }
          } else {
            if (dom === 4 && inf === 4) {
              return x;
            } else {
              return false;
            }
          }
        })
      );
    },
  },
};
</script>
